import React, { useState, useEffect, Fragment } from 'react'
import { Link } from 'react-router-dom';

const CardNews = ({data,setActualizar}) => {
    const [news, setNews] = useState({})
    useEffect(() => {
      setNews(data)
    }, [data]);

    function eliminarNews(){
        fetch('/rt_news', {
            method: 'DELETE',
            body: JSON.stringify({id: data.ID_NE}),
            headers: {'Content-Type': 'application/json'}
        })
        .then(res => res.json())
        .then(res => {
            setActualizar(true);
        })
        .catch(err => console.log('Error: '+err))
    }

    function ocultarMostrarNews(){
        fetch('/rt_news', {
            method: 'SUBSCRIBE',
            body: JSON.stringify({id: data.ID_NE}),
            headers: {'Content-Type': 'application/json'}
        })
        .then(res => res.json())
        .then(res => {
            console.log(res);
            setActualizar(true);
        })
        .catch(err => console.log('Error: '+err))
    }

    return (
    <Fragment>
        <div className="col-md-6 mb-4">
            <div className="cardSpeaker">
                <div className="cardHeader">
                    <small className="cardLabel">Publication date: {news.date}</small>
                </div>
                <div className="cardBody">

                    {/* <p className="cardBlockInf"><span className="cardLabel">Date:</span> {news.SPEAKER_NAME_SPK}</p> */}
                    <p className="cardBlockInf"><span className="cardLabel">Title:</span> {news.TITLE_NE}</p>
                    {/* <p className="cardBlockInf textOverflow"><span className="cardLabel">Description:</span> {news.BIO_SPK}</p> */}
                    <p className="cardBlockInf"><span className="cardLabel">Image:</span> {news.PICTURE_NE}</p>
                    {/* <p><strong>Order: </strong> 1</p> */}
                </div>
                <div className="cardFooter buttonsTicket">
                    <Link to={`/news-edit/`+news.ID_NE}><button className="btnTicket edit"><i className="fa-regular fa-pen-to-square"></i> Edit</button></Link>
                    <button className="btnTicket delete" onClick={eliminarNews}><i className="fa-regular fa-trash-can"></i> Delete</button>
                    {
                        news.IS_VISIBLE_NE ?
                        <button className="btnTicket unhide" onClick={ocultarMostrarNews}><i className="fa-regular fa-eye"></i> Unhide</button>
                        :<button className="btnTicket hide" onClick={ocultarMostrarNews}><i className="fa-regular fa-eye-slash"></i> Hide</button>
                    }
                </div>
            </div>
        </div>
    </Fragment>
    );
}
 
export default CardNews;